import React, { useMemo } from "react";
import { Alert } from "antd";
import { MultiShopSelectPlatformType, MultiShopSelectPlatformTypeName } from "@/components/MultiShopSelect/types";
import { PlatformOrderInfo } from ".";
import OrderDTO from "@/dto/order/OrderDTO";
import { classifyPlatformOrderInfo } from "./utils";

interface WaybillAlertProps {
    platformOrderInfo: PlatformOrderInfo;
    orders: OrderDTO[];
}

const WaybillAlert: React.FC<WaybillAlertProps> = function (props) {
    const { platformOrderInfo } = props;
    const text: string[] = [];

    const { aliPlatformOrderInfo, standardPlatformOrderInfo, otherDropShippingSupplierPlatformOrderInfo } = useMemo(
        () => {
            return classifyPlatformOrderInfo(platformOrderInfo);
        },
        [platformOrderInfo],
    );

    Object.keys(standardPlatformOrderInfo).map((platform) => {
        const count = platformOrderInfo[platform].length;

        if (count) {
            text.push(`${MultiShopSelectPlatformTypeName[platform]}订单${count}个`);
        }
    });

    if (Object.keys(aliPlatformOrderInfo).length) {
        const aliOutOrderTexts = [];

        let total = 0;

        Object.keys(aliPlatformOrderInfo).map((platform) => {
            const count = platformOrderInfo[platform].length;

            total += count;

            if (platform !== MultiShopSelectPlatformType.ali && count) {
                aliOutOrderTexts.push(`${MultiShopSelectPlatformTypeName[platform]}订单${count}个`);
            }
        });

        const aliText =
            `${MultiShopSelectPlatformTypeName[MultiShopSelectPlatformType.ali]}订单${total}个 ` +
            (aliOutOrderTexts.length ? "其中" : "") +
            aliOutOrderTexts.join();

        text.push(aliText);
    }

    if (Object.keys(otherDropShippingSupplierPlatformOrderInfo).length) {
        const otherDropShippingSupplierTexts = [];
        let total = 0;

        Object.keys(otherDropShippingSupplierPlatformOrderInfo).map((platform) => {
            const count = platformOrderInfo[platform].length;

            total += count;

            if (count) {
                otherDropShippingSupplierTexts.push(`${MultiShopSelectPlatformTypeName[platform]}订单${count}个`);
            }
        });

        text.push(`其他代发订单${total}个 其中${otherDropShippingSupplierTexts.join()}`);
    }

    return <Alert type="info" className="mb10" showIcon title={text.join("；")}></Alert>;
};

export default React.memo(WaybillAlert);
